// `import type`: só o tipo. Import de valor aqui fecharia um ciclo em runtime com
// `types/checklist.ts`, que consome `ehFamiliaSaida` no `isServiceVisible`.
import type { ChecklistType } from '../types/checklist';

/**
 * As famílias de checklist (at-96) — regra única do frontend, espelho de
 * `oficina-app-backend/src/common/checklist-familias.ts`.
 *
 * 🔴 POR QUE ISTO EXISTE: até a at-96 havia UM tipo de saída, e `type !== 'SAIDA'` significava
 * "é entrada". Com `POS_EVENTO_SAIDA` no enum, essa expressão passa a classificar a saída de um
 * pós-evento como entrada — e nada quebra: tipos, build e testes continuam verdes, e a tela
 * mostra o checklist errado.
 *
 * ⚠️ A lista de entrada estava DUPLICADA em `recepcao.tsx` e `EntreguesTab.tsx` (o
 * `ENTRADA_FAMILY` literal). Divergir do backend produz tela que não acha o checklist de
 * entrada de um atendimento que tem um.
 */

export const FAMILIA_ENTRADA: ChecklistType[] = ['ENTRADA', 'POS_EVENTO_ENTRADA'];

export const FAMILIA_SAIDA: ChecklistType[] = ['SAIDA', 'POS_EVENTO_SAIDA'];

export const ehFamiliaEntrada = (tipo?: string | null): boolean =>
  !!tipo && (FAMILIA_ENTRADA as string[]).includes(tipo);

export const ehFamiliaSaida = (tipo?: string | null): boolean =>
  !!tipo && (FAMILIA_SAIDA as string[]).includes(tipo);

/**
 * O tipo de checklist que ESTE atendimento aceita (at-96).
 *
 * O tipo é derivado, não escolhido: o backend recusa o par errado com
 * `409 CHECKLIST_TIPO_INCOMPATIVEL`, e a tela mostra qual checklist vai ser feito.
 */
export const tipoDeEntradaDoAtendimento = (ehPosEvento: boolean): ChecklistType =>
  ehPosEvento ? 'POS_EVENTO_ENTRADA' : 'ENTRADA';

export const tipoDeSaidaDoAtendimento = (ehPosEvento: boolean): ChecklistType =>
  ehPosEvento ? 'POS_EVENTO_SAIDA' : 'SAIDA';
